import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface PublicRouteProps {
    children: React.ReactNode;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
    const { user, isLoading } = useAuth();

    if (isLoading) {
        return <div>Loading...</div>; // Or your loading component
    }

    if (user) {
        return <Navigate to="/" />; // Redirect to home if already logged in
    }

    return <>{children}</>;
};

export default PublicRoute;
